import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const Documentacion: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <h1>
        <a href='https://docs.google.com/document/d/1HptnBZWk8ZS4mT50u9NiYahKZh85SrNGGk1owZGQQAM/edit'>
          Documentacion de un proyecto
        </a>
      </h1>
      <div
        className='alert alert-primary d-flex align-items-center'
        role='alert'>
        <svg
          className='bi flex-shrink-0 mr-2'
          width='24'
          height='24'
          role='img'
          aria-label='Info:'>
          <use href='#info-fill' />
        </svg>
        <div>
          <strong>Tu código debe leerlo una persona</strong>, no una máquina.
        </div>
      </div>
      <p className='text-justify'>
        Recordá siempre que el código que programas debe poder ser leído por una
        persona, no por una máquina. Si no nos interesara que nuestro código
        pueda ser leído por personas, escribiríamos en binario.
      </p>
      <p className='text-justify'>
        Existen varias pautas que hay que tener en cuenta a la hora escribir un
        código legible. Y estas suelen entrar dentro del gran tema{" "}
        <strong>Documentación</strong>. Para hacer un código apropiadamente
        documentado hay un par de tips que podes tener en cuenta. Pero el
        mensaje al principio de este documento es la regla dorada.{" "}
        <i>
          <strong>Tu código debe leerlo una persona</strong>, no una máquina
        </i>
        .
      </p>
      <h2>Si necesita comentarios, le falta claridad</h2>
      <p className='text-justify'>
        En normas generales, si tu código necesita de varios comentarios para
        poder entender que es lo que está haciendo, es porque tu código no es
        claro. La mayoría de los lenguajes y frameworks que utilizamos en
        Crombie permiten estílos de programación declarativos que permiten
        declarar lo que nuestro código debe hacer de una manera ordenada y rica
        semánticamente. Toma por ejemplo el algorítmo a continuación:
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`let a = [3, 5, 9, 2, 6, 8];
let x = 0;
let b = false;
while (!b) {
	for(let j = x; j < 6; j++) {
		if (j === 5) break;
		if (a[j] > a[j+1]) {
			let c = a[j];
			a[j] = a[j+1];
			a[j+1] = c;
		}
	}
	b = true;
	for (let j = x; j < 6; j++) {
		if (j === 5) break;
		if (a[j] > a[j+1]) {
			b = false;
			break;
		}
	}
}`}
          </code>
        </pre>
        Uno de los problemas principales que tiene este código, es la mala
        nomenclatura de variables. Esto hace que tengamos que ver las
        instrucciones imperativas para entender que es lo que obtiene por
        resultado, en vez de interpretar instrucciónes declarativas que nos
        dicen que es lo que hacen (sin tener que preocuparnos en el cómo lo
        hacen). Solo asignando nombres apropiados y eliminando variables
        innecesarias obtenemos algo mucho mejor:
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`let array = [3, 5, 9, 2, 6, 8];
let isSorted = false;
while (!isSorted) {
	for(let index = 0; index < 6; index++) {
		if (index === 5) break;
		if (a[index] > a[index+1]) {
			let c = a[index];
			a[index] = a[index+1];
			a[index+1] = c;
		}
	}
	isSorted = true;
	for (let index = 0; index < 6; index++) {
		if (index === 5) break;
		if (a[index] > a[index+1]) {
			isSorted = false;
			break;
		}
	}
}`}
          </code>
        </pre>
        Ahora si se vuelve mucho más sencillo entender que es lo que está
        haciendo el código, pero sigue siendo complejo y muy imperativo. La
        mayoría de los lenguajes y frameworks con lo que trabajamos en Crombie
        tienen funciones que nos permiten programar de manera declarativa. Sin
        tener que definir cada paso intermedio. En muchos proyectos en Crombie,
        esto suele ser mejor.
        <div
          className='alert alert-warning d-flex align-items-center mt-2'
          role='alert'>
          Recorda que a veces la mantenibilidad del código es incluso más
          importante que la performance. Sobre todo trabajando en Front End
        </div>
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`const unsortedArray = [3, 5, 9, 2, 6, 8];
const sortedArray = unsorted.sort((a,b) => a - b);`}
          </code>
        </pre>
        Y así obtenemos un algorítmo que hace exactamente lo que querémos sin
        tener que entrar en demasiado detalle de cómo lo queremos y ahorrando
        lineas de código que pueden traer errores.
      </p>
    </Container>
  );
};

export default new Content({
  Component: Documentacion,
  title: "Documentación",
  route: "documentacion",
  tags: [
    "buenas",
    "practicas",
    "documentacion",
    "proyecto",
    "fundamentos",
    "reglas",
    "calidad",
    "procesos",
    "code",
    "quality",
    "code quality",
    "process"
  ]
});
